const ocuppation = [
    {
        id:1,
        value:"Comerciante"
    },
    {
        id:2,
        value:"Empleado"
    },
    {
        id:3,
        value:"Empresario"
    },
    {
        id:4,
        value:"Permisionario"
    },
    {
        id:5,
        value:"Otro"
    },
    {
        id:6,
        value:"Transportista"
    },
    {
        id:7,
        value:"Hogar"
    }
]
const proffesion = [
    {
        id:1,
        value:"Administrador"
    },
    {
        id:2,
        value:"Abogado"
    },
    {
        id:3,
        value:"Arquitecto"
    },
    {
        id:4,
        value:"Acturario"
    },
    {
        id:5,
        value:"Contador"
    },
    {
        id:6,
        value:"Docente"
    },
    {
        id:7,
        value:"Economista"
    },
    {
        id:8,
        value:"Ingeniero"
    },
    {
        id:9,
        value:"Médico"
    },
    {
        id:10,
        value:"Psicólogo"
    },
    {
        id:11,
        value:"Odontólogo"
    },
    {
        id:12,
        value:"Químico"
    },
    {
        id:13,
        value:"Biólogo"
    },
    {
        id:14,
        value:"Sociólogo"
    },
    {
        id:15,
        value:"Periodista"
    },
    {
        id:16,
        value:"Otro"
    },
    {
        id:17,
        value:"Ninguna"
    }
]
const Activity = [
    {
        id:10,
        value:"Industrial"
    },
    {
        id:20,
        value:"Comercial"
    },
    {
        id:30,
        value:"Servicios"
    },
    {
        id:31,
        value:"Serv. Públicos"
    },
    {
        id:32,
        value:"Serv. Privados"
    },
    {
        id:33,
        value:"Transporte"
    },
    {
        id:34,
        value:"Turismo"
    },
    {
        id:35,
        value:"Instituciones Financieras"
    },
    {
        id:36,
        value:"Educación"
    },
    {
        id:37,
        value:"Salubridad"
    },
    {
        id:38,
        value:"Fianzas y Seguros"
    },
    {
        id:39,
        value:"Act Vul/Ofrecimiento/Prestación de Servicios"
    },
    {
        id:40,
        value:"Emisión/Compra/Venta/Distrución"
    },
    {
        id:41,
        value:"Act Vul Otros"
    },
    {
        id:42,
        value:"Otros"
    }
]
const BornEntity = [
    {
        id:"AS",
        value:"AGUASCALIENTES"
    },
    {
        id:"BC",
        value:"BAJA CALIFORNIA"
    },
    {
        id:"BS",
        value:"BAJA CALIFORNIA SUR"
    },
    {
        id:"CC",
        value:"CAMPECHE"
    },
    {
        id:"CL",
        value:"COAHUILA"
    },
    {
        id:"CM",
        value:"COLIMA"
    },
    {
        id:"CS",
        value:"CHIAPAS"
    },
    {
        id:"DF",
        value:"DISTRITO FEDERAL"
    },
    {
        id:"DG",
        value:"DURANGO"
    },
    {
        id:"GT",
        value:"GUANAJUATO"
    },
    {
        id:"GR",
        value:"GUERRERO"
    },
    {
        id:"HG",
        value:"HIDALGO"
    },
    {
        id:"JC",
        value:"JALISCO"
    },
    {
        id:"MC",
        value:"MEXICO"
    },
    {
        id:"MIN",
        value:"MICHOACAN"
    },
    {
        id:"MS",
        value:"MORELOS"
    },
    {
        id:"NT",
        value:"NAYARIT"
    },
    {
        id:"NL",
        value:"NUEVO LEON"
    },
    {
        id:"OC",
        value:"OAXACA"
    },
    {
        id:"PL",
        value:"PUEBLA"
    },
    {
        id:"QT",
        value:"QUERETARO"
    },
    {
        id:"QR",
        value:"QUINTANA ROO"
    },
    {
        id:"SP",
        value:"SAN LUIS POTOSI"
    },
    {
        id:"SL",
        value:"SINALOA"
    },
    {
        id:"TC",
        value:"TABASCO"
    },
    {
        id:"TS",
        value:"TAMAULIPAS"
    },
    {
        id:"TL",
        value:"TLAXCALA"
    },
    {
        id:"VZ",
        value:"VERACRUZ"
    }
]
const ResidencyType = [
    {
        id:1,
        value:"Temporal"
    },
    {
        id:2,
        value:"Permanente"
    },
    {
        id:3,
        value:"Residente"
    }
]
const Countries = [
    {
        id:"002",
        value:"Afganistan"
    },
    {
        id:"003",
        value:"Albania"
    },
    {
        id:"004",
        value:"Alemania"
    },
    {
        id:"005",
        value:"Andorra"
    },
    {
        id:"006",
        value:"Angola"
    },
    {
        id:"007",
        value:"Antigua y Barbuda"
    },
    {
        id:"008",
        value:"Arabia Saudita"
    },
    {
        id:"009",
        value:"Argelia"
    },
    {
        id:"010",
        value:"Argentina"
    },
    {
        id:"011",
        value:"Armenia"
    },
    {
        id:"012",
        value:"Australia"
    },
    {
        id:"013",
        value:"Austria"
    },
    {
        id:"014",
        value:"Azerbaiyan"
    },
    {
        id:"015",
        value:"Bahamas"
    },
    {
        id:"016",
        value:"Banglades"
    },
    {
        id:"017",
        value:"Barbados"
    },
    {
        id:"018",
        value:"Barein"
    },
    {
        id:"019",
        value:"Belgica"
    },
    {
        id:"020",
        value:"Belice"
    },
    {
        id:"021",
        value:"Benin"
    },
    {
        id:"022",
        value:"Bielorrusia"
    },
    {
        id:"023",
        value:"Birmania"
    },
    {
        id:"024",
        value:"Bolivia"
    },
    {
        id:"025",
        value:"Bosnia y Herzegovina"
    },
    {
        id:"026",
        value:"Botsuana"
    },
    {
        id:"027",
        value:"Brasil"
    },
    {
        id:"028",
        value:"Brunei"
    },
    {
        id:"029",
        value:"Bulgaria"
    },
    {
        id:"030",
        value:"Burkina Faso"
    },
    {
        id:"031",
        value:"Burundi"
    },
    {
        id:"032",
        value:"Butan"
    },
    {
        id:"033",
        value:"Cabo Verde"
    },
    {
        id:"034",
        value:"Camboya"
    },
    {
        id:"035",
        value:"Camerun"
    },
    {
        id:"036",
        value:"Canada"
    },
    {
        id:"037",
        value:"Catar"
    },
    {
        id:"038",
        value:"Chad"
    },
    {
        id:"039",
        value:"Chile"
    },
    {
        id:"040",
        value:"China"
    },
    {
        id:"041",
        value:"Chipre"
    },
    {
        id:"042",
        value:"Ciudad del Vaticano"
    },
    {
        id:"043",
        value:"Colombia"
    },
    {
        id:"044",
        value:"Comoras"
    },
    {
        id:"045",
        value:"Corea del Norte"
    },
    {
        id:"046",
        value:"Corea del Sur"
    },
    {
        id:"047",
        value:"Costa de Marfil"
    },
    {
        id:"048",
        value:"Costa Rica"
    },
    {
        id:"049",
        value:"Croacia"
    },
    {
        id:"050",
        value:"Cuba"
    },
    {
        id:"051",
        value:"Dinamarca"
    },
    {
        id:"052",
        value:"Dominica"
    },
    {
        id:"053",
        value:"Ecuador"
    },
    {
        id:"054",
        value:"Egipto"
    },
    {
        id:"055",
        value:"El Salvador"
    },
    {
        id:"056",
        value:"Emirates Arabes Unidos"
    },
    {
        id:"057",
        value:"Entrea"
    },
    {
        id:"058",
        value:"Eslovaquia"
    },
    {
        id:"059",
        value:"Eslovenia"
    },
    {
        id:"060",
        value:"España"
    },
    {
        id:"061",
        value:"Estados Unido"
    },
    {
        id:"062",
        value:"Estonia"
    },
    {
        id:"063",
        value:"Etiopia"
    },
    {
        id:"064",
        value:"Filipinas"
    },
    {
        id:"065",
        value:"Finlandia"
    },
    {
        id:"066",
        value:"Fiyi"
    },
    {
        id:"067",
        value:"Francia"
    },
    {
        id:"068",
        value:"Gabón"
    },
    {
        id:"069",
        value:"Gambia"
    },
    {
        id:"070",
        value:"Georgia"
    },
    {
        id:"071",
        value:"Ghana"
    },
    {
        id:"072",
        value:"Granada"
    },
    {
        id:"073",
        value:"Grecia"
    },
    {
        id:"074",
        value:"Guatemala"
    },
    {
        id:"075",
        value:"Guayana"
    },
    {
        id:"076",
        value:"Ginea"
    },
    {
        id:"077",
        value:"Ginea Ecuatorial"
    },
    {
        id:"078",
        value:"Guinea-Bisau"
    },
    {
        id:"079",
        value:"Haití"
    },
    {
        id:"080",
        value:"Honduras"
    },
    {
        id:"081",
        value:"Hungria"
    },
    {
        id:"082",
        value:"India"
    },
    {
        id:"083",
        value:"Indonesia"
    },
    {
        id:"084",
        value:"Irak"
    },
    {
        id:"085",
        value:"Iran"
    },
    {
        id:"086",
        value:"Irlanda"
    },
    {
        id:"087",
        value:"Islandia"
    },
    {
        id:"088",
        value:"Islas Marshall"
    },
    {
        id:"089",
        value:"Islas Salomon"
    },
    {
        id:"090",
        value:"Israel"
    },
    {
        id:"091",
        value:"Italia"
    },
    {
        id:"092",
        value:"Jamaica"
    },
    {
        id:"093",
        value:"Japon"
    },
    {
        id:"094",
        value:"Jordania"
    },
    {
        id:"095",
        value:"Kazajistan"
    },
    {
        id:"096",
        value:"Kenia"
    },
    {
        id:"097",
        value:"Kirguistan"
    },
    {
        id:"098",
        value:"Kiribati"
    },
    {
        id:"099",
        value:"Kuwait"
    },
    {
        id:"100",
        value:"Laos"
    },
    {
        id:"101",
        value:"Lesoto"
    },
    {
        id:"102",
        value:"Letonia"
    },
    {
        id:"103",
        value:"Libano"
    },
    {
        id:"104",
        value:"Liberia"
    },
    {
        id:"105",
        value:"Libia"
    },
    {
        id:"106",
        value:"Liechtenstein"
    },
    {
        id:"107",
        value:"Lituania"
    },
    {
        id:"108",
        value:"Luxemburgo"
    },
    {
        id:"109",
        value:"Madagascar"
    },
    {
        id:"110",
        value:"Malasia"
    },
    {
        id:"111",
        value:"Malaui"
    },
    {
        id:"112",
        value:"Maldivas"
    },
    {
        id:"113",
        value:"Mali"
    },
    {
        id:"114",
        value:"Malta"
    },
    {
        id:"115",
        value:"Marruecos"
    },
    {
        id:"116",
        value:"Mauricio"
    },
    {
        id:"117",
        value:"Mauritania"
    },
    {
        id:"118",
        value:"Micronesia"
    },
    {
        id:"119",
        value:"Moldavia"
    },
    {
        id:"120",
        value:"Monaco"
    },
    {
        id:"121",
        value:"Mongolia"
    },
    {
        id:"122",
        value:"Montenegro"
    },
    {
        id:"123",
        value:"Mozambique"
    },
    {
        id:"124",
        value:"Namibia"
    },
    {
        id:"125",
        value:"Nauru"
    },
    {
        id:"126",
        value:"Nepai"
    },
    {
        id:"127",
        value:"Nicaragua"
    },
    {
        id:"128",
        value:"Niger"
    },
    {
        id:"129",
        value:"Nigeria"
    },
    {
        id:"130",
        value:"Noruega"
    },
    {
        id:"131",
        value:"Nueva Zelanda"
    },
    {
        id:"132",
        value:"Oman"
    },
    {
        id:"133",
        value:"Paises Bajos"
    },
    {
        id:"134",
        value:"Pakistan"
    },
    {
        id:"135",
        value:"Palaos"
    },
    {
        id:"136",
        value:"Panama"
    },
    {
        id:"137",
        value:"Papua Nueva Guinea"
    },
    {
        id:"138",
        value:"Paraguay"
    },
    {
        id:"139",
        value:"Perú"
    },
    {
        id:"140",
        value:"Polonia"
    },
    {
        id:"141",
        value:"Portugal"
    },
    {
        id:"142",
        value:"Reino Unido"
    },
    {
        id:"143",
        value:"Republica CentroAfricana"
    },
    {
        id:"144",
        value:"Republica Checa"
    },
    {
        id:"145",
        value:"Republica de Macedonia"
    },
    {
        id:"146",
        value:"Republica del Congo"
    },
    {
        id:"147",
        value:"Republica Democratica del Congo"
    },
    {
        id:"148",
        value:"Republica Dominicana"
    },
    {
        id:"149",
        value:"Republica Sudafricana"
    },
    {
        id:"150",
        value:"Ruanda"
    },
    {
        id:"151",
        value:"Rumania"
    },
    {
        id:"152",
        value:"Rusia"
    },
    {
        id:"153",
        value:"Samoa"
    },
    {
        id:"154",
        value:"San Cristobal y Nieves"
    },
    {
        id:"155",
        value:"San Marino"
    },
    {
        id:"156",
        value:"San Vicente y las Granadinas"
    },
    {
        id:"157",
        value:"Santa Lucia"
    },
    {
        id:"158",
        value:"Sant Tome y Principe"
    },
    {
        id:"159",
        value:"Senegal"
    },
    {
        id:"160",
        value:"Serbia"
    },
    {
        id:"161",
        value:"Seychelles"
    },
    {
        id:"162",
        value:"Sierra Leona"
    },
    {
        id:"163",
        value:"Singapur"
    },
    {
        id:"164",
        value:"Siria"
    },
    {
        id:"165",
        value:"Somalia"
    },
    {
        id:"166",
        value:"Sri Lanka"
    },
    {
        id:"167",
        value:"Suazilandia"
    },
    {
        id:"168",
        value:"Sudan"
    },
    {
        id:"169",
        value:"Sudan del Sur"
    },
    {
        id:"170",
        value:"Suecia"
    },
    {
        id:"171",
        value:"Suiza"
    },
    {
        id:"172",
        value:"Surinam"
    },
    {
        id:"173",
        value:"Tailandia"
    },
    {
        id:"174",
        value:"Tanzania"
    },
    {
        id:"175",
        value:"Tayikistan"
    },
    {
        id:"176",
        value:"Timor Oriental"
    },
    {
        id:"177",
        value:"Tongo"
    },
    {
        id:"178",
        value:"Tonga"
    },
    {
        id:"179",
        value:"Trinidad y Tobago"
    },
    {
        id:"180",
        value:"Tunez"
    },
    {
        id:"181",
        value:"Turkmenistan"
    },
    {
        id:"182",
        value:"Turquia"
    },
    {
        id:"183",
        value:"Tuvalu"
    },
    {
        id:"184",
        value:"Ucrania"
    },
    {
        id:"185",
        value:"Uganda"
    },
    {
        id:"186",
        value:"Uruguay"
    },
    {
        id:"187",
        value:"Uzbekistan"
    },
    {
        id:"188",
        value:"Vanutu"
    },
    {
        id:"189",
        value:"Venezuela"
    },
    {
        id:"190",
        value:"Vietnam"
    },
    {
        id:"191",
        value:"Yemen"
    },
    {
        id:"192",
        value:"Yibuti"
    },
    {
        id:"193",
        value:"Zambia"
    },
    {
        id:"194",
        value:"Zimbabue"
    },
    {
        id:"195",
        value:"Abjasia"
    },
    {
        id:"196",
        value:"Acrotin y Dhekelia"
    },
    {
        id:"197",
        value:"Anguilia"
    },
    {
        id:"198",
        value:"Aruba"
    },
    {
        id:"199",
        value:"Bermudas"
    },
    {
        id:"200",
        value:"Chipre del Norte"
    },
    {
        id:"201",
        value:"Curazao"
    },
    {
        id:"202",
        value:"Gibraltar"
    },
    {
        id:"203",
        value:"Groenlandia"
    },
    {
        id:"204",
        value:"Guam"
    },
    {
        id:"205",
        value:"Gemsey"
    },
    {
        id:"206",
        value:"Hong Kong"
    },
    {
        id:"207",
        value:"Isla de Man"
    },
    {
        id:"208",
        value:"Isla Norfolk"
    },
    {
        id:"209",
        value:"Islas Caiman"
    },
    {
        id:"210",
        value:"Islas Cocos"
    },
    {
        id:"211",
        value:"Islas Cook"
    },
    {
        id:"212",
        value:"Islas Feroe"
    },
    {
        id:"213",
        value:"Islas Malvinas"
    },
    {
        id:"214",
        value:"Islas Marianas del Norte"
    },
    {
        id:"215",
        value:"Islas Pitcaim"
    },
    {
        id:"216",
        value:"Jersey"
    },
    {
        id:"217",
        value:"Kosovo"
    },
    {
        id:"218",
        value:"Macao"
    },
    {
        id:"219",
        value:"Monserrat"
    },
    {
        id:"220",
        value:"Nagorno Karabaj"
    },
    {
        id:"221",
        value:"Isla de Naviidad"
    },
    {
        id:"222",
        value:"Niue"
    },
    {
        id:"223",
        value:"Nueva Caledonia"
    },
    {
        id:"224",
        value:"Nueva Rusia"
    },
    {
        id:"225",
        value:"Osetia del Sur"
    },
    {
        id:"226",
        value:"Palestina"
    },
    {
        id:"227",
        value:"Polinesia Francesa"
    },
    {
        id:"228",
        value:"Puerto Rico"
    },
    {
        id:"229",
        value:"Shara Occidental"
    },
    {
        id:"230",
        value:"Samoa Americana"
    },
    {
        id:"231",
        value:"San Bartolome"
    },
    {
        id:"232",
        value:"San Martin"
    },
    {
        id:"233",
        value:"San Pedro y Misquelon"
    },
    {
        id:"234",
        value:"Santa Elena, Ascensión y Tristan"
    },
    {
        id:"235",
        value:"Sint Maarten"
    },
    {
        id:"236",
        value:"Somalilandia"
    },
    {
        id:"237",
        value:"Svalbard"
    },
    {
        id:"238",
        value:"Taiwan"
    },
    {
        id:"239",
        value:"Tokelau"
    },
    {
        id:"240",
        value:"Transnustria"
    },
    {
        id:"241",
        value:"Turcas y Caicos"
    },
    {
        id:"242",
        value:"Islas Virgenes Britanicas"
    },
    {
        id:"243",
        value:"Islas Virgenes de los EU"
    },
    {
        id:"244",
        value:"Wallis y Futuna"
    }
]
const National = [
    {
        id:1,
        value: "Mexicana"
    },
    {
        id:2,
        value: "Extranjera"
    }
]

export {
    ocuppation,
    proffesion,
    Activity,
    BornEntity,
    ResidencyType,
    Countries, 
    National
}